import { OrderListItem } from '@shared/model/order';
import { UserPreview } from '@shared/model/user';

export const orderUsersCount = (order: OrderListItem) => {
    const usersSet = order.requests.reduce(
        (acc, request) => {
            const user = request?.user;
            acc[user?.id] = user;
            return acc;
        },
        {} as Record<string, UserPreview>
    );

    const usersList = Object.values(usersSet);

    return {
        orderUsersLength: usersList.length,
        orderUsers: usersList,
    };
};
